import { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { hasPerm } from "../utils/permission";

/* helpers */
// const API_BASE = process.env.REACT_APP_API_BASE || "https://backend.macustore.com";
const API_BASE = process.env.REACT_APP_API_BASE || "https://backend.suvidhape.in";
const toUrl = (p) =>
  p ? (p.startsWith("http") ? p : `${API_BASE}${p}`) : "/assets/images/avatars/avatar-1.png";

/* auth‑wrapper fetch */
const authFetch = (url, opts = {}) =>
  fetch(url, {
    ...opts,
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

export default function Topbar() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [avatar, setAvatar] = useState("/assets/images/avatars/avatar-1.png");

  const [mainWallet, setMainWallet] = useState(0);
  const [payinWallet, setPayinWallet] = useState(0);
  const [holding_payout_wallet, setHoldMainWallet] = useState(0);
  const [holding_payin_wallet, setHoldPayinWallet] = useState(0);
  const [open, setOpen] = useState(false);
  
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setOpen(true);
    } else {
      document.exitFullscreen();
      setOpen(false);
    }
  };

  /* reusable loader */
  const refreshProfile = useCallback(async () => {
    const raw = localStorage.getItem("user");
    if (!raw) return;                     // not logged in
    let cached;
    try {
      cached = JSON.parse(raw);
    } catch {
      return;
    }

    try {
      const res = await authFetch(`${API_BASE}/api/v1/member/profile/${cached.id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const fresh = data.user || {};
      const freshPic = toUrl(fresh.profilepic);

      setMainWallet(fresh.mainwallet || 0);
      setPayinWallet(fresh.payinwallet || 0);
      setHoldMainWallet(fresh.holding_payout_wallet || 0);
      setHoldPayinWallet(fresh.holding_payin_wallet || 0);

      // alert(fresh.holding_payout_wallet);


      /* state set */
      setUserName(fresh.name || cached.name || "");
      setAvatar(freshPic);

      /* localStorage cache refresh */
      localStorage.setItem(
        "user",
        JSON.stringify({ ...cached, name: fresh.name, profilepic: fresh.profilepic })
      );
    } catch (err) {
      console.warn("Topbar: failed to fetch profile", err.message);
      /* fallback to whatever is in localStorage already */
      setUserName(cached?.name || "");
      setAvatar(toUrl(cached?.profilepic));
    }
  }, []);

  /* mount + listeners */
  useEffect(() => {
    refreshProfile();                      // first load

    /* if any tab updates user in localStorage */
    const onStorage = (e) => (e.key === "user" ? refreshProfile() : null);

    /* custom event we dispatch after profile save */
    window.addEventListener("storage", onStorage);
    window.addEventListener("userUpdate", refreshProfile);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("userUpdate", refreshProfile);
    };
  }, [refreshProfile]);

  /* logout */
  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("perms");

    if (token) {
      try {
        await fetch(`${API_BASE}/api/v1/auth/logout`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch {}
    }
    navigate("/");
  };
    return (
        <>
        <style>{`
    .logout-icon {
      font-size: 22px;
      background: linear-gradient(45deg, #ff416c, #ff4b2b);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: logoutPulse 1.5s infinite;
    }

    @keyframes logoutPulse {
      0% {
        transform: scale(1);
        filter: drop-shadow(0 0 2px rgba(255,65,108,0.5));
      }
      50% {
        transform: scale(1.2);
        filter: drop-shadow(0 0 8px rgba(255,75,43,0.9));
      }
      100% {
        transform: scale(1);
        filter: drop-shadow(0 0 2px rgba(255,65,108,0.5));
      }
    }
    .wallet-icon {
      font-size: 22px;
      background: linear-gradient(58deg, #673ab7, #f70000ff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: walletShake 1.5s infinite;
    }

    @keyframes walletShake {
      0% { transform: rotate(0deg); }
      20% { transform: rotate(-10deg); }
      40% { transform: rotate(10deg); }
      60% { transform: rotate(-6deg); }
      80% { transform: rotate(6deg); }
      100% { transform: rotate(0deg); }
    }
    `}</style> 
        <header className="top-header">
        <nav className="navbar navbar-expand">
          <div className="left-topbar d-flex align-items-center">
            <a href="#" className="toggle-btn">	<i className="bx bx-menu" />
            </a>
          </div>
          <div className="flex-grow-1 search-bar">
            <div className="input-group">
              <h5 className="text-capitalize">Welcome To My Dashboard</h5>
              {/* <button className="btn btn-search-back search-arrow-back" type="button"><i className="bx bx-arrow-back" /></button>
              <input type="text" className="form-control" placeholder="search" />
              <button className="btn btn-search" type="button"><i className="lni lni-search-alt" /></button> */}
            </div>
          </div>
          <div className="right-topbar ms-auto ">
            <ul className="navbar-nav">
              <li className="nav-item search-btn-mobile d-none">
                <a className="nav-link position-relative" href="#">	<i className="bx bx-search vertical-align-middle" />
                </a>
              </li>
              <li className="nav-item dropdown dropdown-lg d-none">
                <a className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" href="#" data-bs-toggle="dropdown">	<span className="msg-count">6</span>
                  <i className="bx bx-comment-detail vertical-align-middle" />
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  <a href="#">
                    <div className="msg-header">
                      <h6 className="msg-header-title">6 New</h6>
                      <p className="msg-header-subtitle">Application Messages</p>
                    </div>
                  </a>
                  <div className="header-message-list">
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-1.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Daisy Anderson <span className="msg-time float-end">5 sec
                              ago</span></h6>
                          <p className="msg-info">The standard chunk of lorem</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-2.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Althea Cabardo <span className="msg-time float-end">14
                              sec ago</span></h6>
                          <p className="msg-info">Many desktop publishing packages</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-3.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Oscar Garner <span className="msg-time float-end">8 min
                              ago</span></h6>
                          <p className="msg-info">Various versions have evolved over</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-4.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Katherine Pechon <span className="msg-time float-end">15
                              min ago</span></h6>
                          <p className="msg-info">Making this the first true generator</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-5.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Amelia Doe <span className="msg-time float-end">22 min
                              ago</span></h6>
                          <p className="msg-info">Duis aute irure dolor in reprehenderit</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-6.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Cristina Jhons <span className="msg-time float-end">2 hrs
                              ago</span></h6>
                          <p className="msg-info">The passage is attributed to an unknown</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-7.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">James Caviness <span className="msg-time float-end">4 hrs
                              ago</span></h6>
                          <p className="msg-info">The point of using Lorem</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-8.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Peter Costanzo <span className="msg-time float-end">6 hrs
                              ago</span></h6>
                          <p className="msg-info">It was popularised in the 1960s</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-9.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">David Buckley <span className="msg-time float-end">2 hrs
                              ago</span></h6>
                          <p className="msg-info">Various versions have evolved over</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-10.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Thomas Wheeler <span className="msg-time float-end">2 days
                              ago</span></h6>
                          <p className="msg-info">If you are going to use a passage</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="user-online">
                          <img src="assets/images/avatars/avatar-11.png" className="msg-avatar" alt="user avatar" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Johnny Seitz <span className="msg-time float-end">5 days
                              ago</span></h6>
                          <p className="msg-info">All the Lorem Ipsum generators</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <a href="#">
                    <div className="text-center msg-footer">View All Messages</div>
                  </a>
                </div>
              </li>
              <li className="nav-item dropdown dropdown-lg d-none">
                <a className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" href="#" data-bs-toggle="dropdown">	<i className="bx bx-bell vertical-align-middle" />
                  <span className="msg-count">8</span>
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  <a href="#">
                    <div className="msg-header">
                      <h6 className="msg-header-title">8 New</h6>
                      <p className="msg-header-subtitle">Application Notifications</p>
                    </div>
                  </a>
                  <div className="header-notifications-list">
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-primary text-primary"><i className="bx bx-group" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New Customers<span className="msg-time float-end">14 Sec
                              ago</span></h6>
                          <p className="msg-info">5 new user registered</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-danger text-danger"><i className="bx bx-cart-alt" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New Orders <span className="msg-time float-end">2 min
                              ago</span></h6>
                          <p className="msg-info">You have recived new orders</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-shineblue text-shineblue"><i className="bx bx-file" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">24 PDF File<span className="msg-time float-end">19 min
                              ago</span></h6>
                          <p className="msg-info">The pdf files generated</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-cyne text-cyne"><i className="bx bx-send" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Time Response <span className="msg-time float-end">28 min
                              ago</span></h6>
                          <p className="msg-info">5.1 min avarage time response</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-purple text-purple"><i className="bx bx-home-circle" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New Product Approved <span className="msg-time float-end">2 hrs ago</span></h6>
                          <p className="msg-info">Your new product has approved</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-warning text-warning"><i className="bx bx-message-detail" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New Comments <span className="msg-time float-end">4 hrs
                              ago</span></h6>
                          <p className="msg-info">New customer comments recived</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-success text-success"><i className="bx bx-check-square" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Your item is shipped <span className="msg-time float-end">5 hrs
                              ago</span></h6>
                          <p className="msg-info">Successfully shipped your item</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-sinata text-sinata"><i className="bx bx-user-pin" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">New 24 authors<span className="msg-time float-end">1 day
                              ago</span></h6>
                          <p className="msg-info">24 new authors joined last week</p>
                        </div>
                      </div>
                    </a>
                    <a className="dropdown-item" href="#">
                      <div className="d-flex align-items-center">
                        <div className="notify bg-light-mehandi text-mehandi"><i className="bx bx-door-open" />
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="msg-name">Defense Alerts <span className="msg-time float-end">2 weeks
                              ago</span></h6>
                          <p className="msg-info">45% less alerts last 4 weeks</p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <a href="#">
                    <div className="text-center msg-footer">View All Notifications</div>
                  </a>
                </div>
              </li>
              <li className="nav-item dropdown dropdown-lg ">
                <a className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" href="#" data-bs-toggle="dropdown">	<i className="bx bx-wallet wallet-icon vertical-align-middle" />
                  {/* <span className="msg-count">8</span> */}
                  {/* <span className="msg" style={{ fontSize: "15px" }}>Wallet</span> */}
                  
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  {/* <a href="#"> */}
                  <div className="row">
                    <div className="col-lg-6 col-6">
                      <div className="msg-header">
                        <h6 className="msg-header-title" style={{ fontSize: "15px" }}>Payin Wallet</h6>
                        <p className="msg-header-subtitle">₹{Number(payinWallet).toFixed(2)}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-6">
                      <div className="msg-header">
                        <h6 className="msg-header-title" style={{ fontSize: "15px" }}>Holding Payin Wallet</h6>
                        <p className="msg-header-subtitle">₹{Number(holding_payin_wallet).toFixed(2)}</p>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <div className="row">
                    <div className="col-lg-6 col-6">
                      <div className="msg-header">
                        <h6 className="msg-header-title" style={{ fontSize: "15px" }}>Main Wallet</h6>
                        <p className="msg-header-subtitle">₹{Number(mainWallet).toFixed(2)}</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-6">
                      <div className="msg-header">
                        <h6 className="msg-header-title" style={{ fontSize: "15px" }}>Holding Main Wallet</h6>
                        <p className="msg-header-subtitle">₹{Number(holding_payout_wallet).toFixed(2)}</p>
                      </div>
                    </div>
                  </div>
                    
                  {/* </a> */}
                 
                </div>
              </li>

              {/* <li className="nav-item dropdown dropdown-lg">
  <a
    className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative"
    href="#"
    data-bs-toggle="dropdown"
  >
    <i className="bx bx-wallet vertical-align-middle" />
    <span className="ms-1">Wallet</span>
  </a>

  <div className="dropdown-menu dropdown-menu-end shadow-lg p-3" style={{ minWidth: "260px" }}>
    <div className="msg-header mb-2 border-bottom pb-2">
      <h6 className="msg-header-title mb-0 fw-semibold text-primary">
        Wallet Overview
      </h6>
    </div>

    <div className="d-flex justify-content-between align-items-center mb-2">
      <span className="fw-semibold text-muted">Hold Main Wallet:</span>
      <span className="fw-bold text-dark">₹{Number(holdmainWallet).toFixed(2)}</span>
    </div>

    <div className="d-flex justify-content-between align-items-center mb-2">
      <span className="fw-semibold text-muted">Hold Payin Wallet:</span>
      <span className="fw-bold text-dark">₹{Number(holdpayinWallet).toFixed(2)}</span>
    </div>

    <hr />

    
  </div>
</li> */}


              

              <li className="nav-item dropdown dropdown-user-profile">
                <a className="nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" data-bs-toggle="dropdown">
                  <div className="d-flex user-box align-items-center">
                    <div className="user-info">
                      <p className="user-name mb-0">{userName}</p>
                      <p className="designattion mb-0">Available</p>
                    </div>
                    {/* <img src="assets/images/avatars/avatar-1.png" className="user-img" alt="user avatar" /> */}
                    <img
                    src={avatar}
                    alt="profile"
                    width={40}
                    height={40}
                    className="rounded-circle ms-2"
                    />
                  </div>
                </a>
                
                <div className="dropdown-menu dropdown-menu-end">	
                  <a className="dropdown-item d-lg-none" href="#">
                    <i className="bx bx-user"
                      style={{color: "#ffffff",fontSize: "20px",background: "#000",borderRadius: "50%",padding: "5px"}}
                    />
                    <span style={{fontWeight: 700,fontSize:"16px"}}>{userName}</span>
                    <hr/>
                  </a>
                  {hasPerm("user_profile") && (
                  <Link className="dropdown-item" to="/profile"><i className="bx bx-user" /><span>Profile</span></Link>
                  )}
                  {/* <a className="dropdown-item" href="#"><i className="bx bx-cog" /><span>Settings</span></a>
                  <a className="dropdown-item" href="#"><i className="bx bx-tachometer" /><span>Dashboard</span></a>
                  <a className="dropdown-item" href="#"><i className="bx bx-wallet" /><span>Earnings</span></a>
                  <a className="dropdown-item" href="#"><i className="bx bx-cloud-download" /><span>Downloads</span></a> */}
                  <div className="dropdown-divider mb-0" />	
                  <button className="dropdown-item" onClick={handleLogout} style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}>
                    <i className="bx bx-power-off" />
                    <span>Logout</span>
                  </button>
                </div>
              </li>
              <li className="nav-item dropdown dropdown-language">
                <a className="nav-link" href="#" onClick={(e) => {
                    e.preventDefault();
                    toggleFullscreen();
                  }}
                >
                    <div>
                      <i title="Full Screen" className={`bx ${open ? "bx-collapse" : "bx-expand"}`}></i>
                    </div>
                </a>
              </li>
              <li className="nav-item dropdown dropdown-language">
                <a className="nav-link" href="#" onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                    <div>
                      <i className="bx bx-power-off logout-icon" />
                    </div>
                </a>
              </li>
              {/* <li className="nav-item dropdown dropdown-language">
                <a className="nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" data-bs-toggle="dropdown">
                  <div className="lang d-flex">
                    <div><i className="flag-icon flag-icon-um" />
                    </div>
                    <div><span>En</span>
                    </div>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-de" /><span>German</span></a>
                  <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-fr" /><span>French</span></a>
                  <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-um" /><span>English</span></a>
                  <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-in" /><span>Hindi</span></a>
                  <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-cn" /><span>Chinese</span></a>
                  <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-ae" /><span>Arabic</span></a>
                </div>
              </li> */}
            </ul>
          </div>
        </nav>
      </header>
        </>
    )
}

// export default Topbar